import styled, { css } from "styled-components"

const StyledBannerImage = styled.div`
  ${props => css`
    background-image: url("${props.url}");
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
`}
`
export default StyledBannerImage
